import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

/**
 * POST 서명 취소 - 입력한 서명을 취소합니다.
 *
 * Endpoint path is modified in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#a84e2868f0b84f4d872c7f5f629e7bfa
 */
export function postDocumentsCancelSigning({
  documentId,
  message,
  participantId,
  workspaceId,
}: {
  documentId: string;
  message: string;
  participantId: string;
  workspaceId: string;
}) {
  return requestApi({
    url: withDocument(`/workspaces/${workspaceId}/documents/${documentId}/cancel-signing`),
    method: 'POST',
    data: {
      participantId,
      message,
    },
    credentials: true,
  });
}
